import { validateConnectionExistsById } from '@/components/requestConnectionButton/validateConnectionSentReceived'
import { User } from 'containers/user/types/user'
import { ProfileRecommendation } from '../types/recommendations'

interface FilterRecommendationsParams {
  recommendations?: ProfileRecommendation[]
  user?: User
  profileId: string
}

export const filterRecommendationsByUserAndProfile = ({
  recommendations = [],
  user,
  profileId,
}: FilterRecommendationsParams) => {

  return (
    recommendations?.filter((recommendation) => {
      const isRecommendationSameAsProfile = recommendation?.id === profileId

      if (!user) return !isRecommendationSameAsProfile

      const isRecommendationSameAsUser = recommendation?.id === user.id
      const isRecommendationInConnectionsSent = validateConnectionExistsById({
        id: recommendation?.id,
        connections: user?.connectionsSent || [],
      })
      const isRecommendationInConnectionsReceived =
        validateConnectionExistsById({
          id: recommendation?.id,
          connections: user?.connectionsReceived || [],
        })
      const isAlreadyAConnection = user?.connections?.includes(
        recommendation?.id
      )

      const isInvitationSent = user?.invitationsSent?.includes(
        recommendation?.email
      )

      return (
        !isRecommendationSameAsUser &&
        !isRecommendationSameAsProfile &&
        !isRecommendationInConnectionsSent &&
        !isRecommendationInConnectionsReceived &&
        !isAlreadyAConnection &&
        !isInvitationSent
      )
    }) || []
  )
}
